import { providersApi } from '@/api/agents'
import { ProviderList } from '@/components/ProviderList'
import { adminCopy } from '@/copy'
import { useProviderCrud } from '@/hooks/useProviderCrud'

export function ProvidersTab({
  creating,
  onCreatingChange,
}: {
  creating: boolean
  onCreatingChange: (open: boolean) => void
}) {
  const crud = useProviderCrud({
    queryKey: ['admin', 'providers'],
    api: {
      list: providersApi.list,
      create: (body) => providersApi.create(body),
      update: (id, body) => providersApi.update(id, body),
      delete: (id) => providersApi.delete(id),
    },
  })

  return (
    <ProviderList
      {...crud}
      canManage
      creating={creating}
      onCreatingChange={onCreatingChange}
      canCreate
      emptyText={adminCopy.providers.empty}
    />
  )
}
